import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import store from '../store'
import * as types from '../store/types'
// axios config
axios.defaults.timeout = 30000
axios.defaults.withCredentials = true
axios.defaults.headers = {
  'lang': store.state.user.userinfo === null ? 'en' : store.state.user.userinfo.lang
}

if (window.performance) {
  axios.interceptors.request.use(function (config) {
    config.apiStart = Math.round(performance.now())
    return config
  }, function (error) {
    return Promise.reject(error)
  })
}
// http response interceptor
axios.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('login') === -1 && JSON.parse(window.store.get('userInfo')).id !== store.state.user.userinfo.id) {
      store.commit(types.RESIGN)
    }
    if (window.performance) {
      Vue.$ga.time('API', response.config.url, Math.round(performance.now()) - response.config.apiStart, window.location.host)
    }
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.SIGNOUT)
          router.replace({
            name: 'Login'
          })
          break
        case 403:
          // 403 用户没有访问此URL权限
          router.replace({
            name: 'Dashboard'
          })
      }
    }

    return Promise.reject(error.response.data)
  })

export default axios



// WEBPACK FOOTER //
// ./src/api/http.js